import React from 'react';
interface SectionHeadingProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  id,
  eyebrow,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="text-center" data-id="element-134" data-mp="3jzdn6ldxnocf">
      {eyebrow && <p className={`font-display text-xs font-bold uppercase tracking-wide ${dark ? 'text-electric' : 'text-navy'}`} data-id="element-135" data-mp="3k2043bmprg7b">
          {eyebrow}
        </p>}
      <h2 id={id} className={`mt-1 font-display text-xl font-extrabold leading-tight sm:text-[1.7rem] ${dark ? 'text-white' : 'text-navy'}`} data-id="element-136" data-mp="glav7iznrueh">
        {title}
      </h2>
      {subtitle && <p className={`mx-auto mt-1.5 max-w-xl font-display text-sm font-semibold leading-snug ${dark ? 'text-white/80' : 'text-graphite-muted'}`} data-id="element-137" data-mp="uizfopptczj0">
          {subtitle}
        </p>}
    </div>;
}